/* eslint-disable no-unused-vars */
/* eslint-disable no-useless-escape */
/* eslint-disable no-console */
/* eslint-disable no-undef */
import * as config from "./config";
import Vue from "vue";
import script from "./script";
import dc from "@common/dc";
import qs from "qs";
import store from "@common/store";
const sha1 = require("sha1");
const _UID = "_xni";
const _UNID = "_xnu";
// const cookieSecure = process.env.NODE_ENV === 'development' ? '' : ''
const isAboveChrome70 = window.Browser.chrome
  ? window.Browser.compare(window.Browser.chrome, "70") >= 0
  : false;
const cookieSecure =
  process.env.NODE_ENV === "development"
    ? ""
    : isAboveChrome70
    ? "SameSite=None;Secure;"
    : "";
let socket = null;
let socketListeners = [];
let replaceArr = [];
const htmltaglist = [
  // 所有html标签，用于去除指定标签
  "a",
  "abbr",
  "acronym",
  "address",
  "applet",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "basefont",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "center",
  "cite",
  "code",
  "col",
  "colgroup",
  "command",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "font",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "map",
  "mark",
  "menu",
  "meta",
  "meter",
  "nav",
  "noframes",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strike",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "tt",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
];

export default {
  needMark(classNameOrIdName) {
    const envEle = document.createElement("div");
    const envArr = location.origin.match(/dev|test|localhost|zzb/g);
    console.log("envArr", envArr);
    if (envArr && envArr.length > 0) {
      envEle.innerText = envArr[0] === "dev" ? "开发环境" : "测试环境";
      envEle.setAttribute(
        "style",
        `position: fixed;top:0;left:0;z-index:9999999999999;height: 30px; width: 230px;line-height: 30px;text-align: center;background: ${
          envArr[0] === "dev" ? "green" : "yellow"
        };opacity:1;pointer-events: none;`
      );
      let dom = document.querySelector(`${classNameOrIdName}`);
      if (dom) {
        dom.insertBefore(
          envEle,
          document.querySelector(`${classNameOrIdName}`).firstElementChild
        );
      }
    }
  },
  checkPassWord(str) {
    let regEnUp = /[A-Z]+/, //大写字bai母
      regEnLow = /[a-z]+/, //小写字母
      regNum = /[0-9]+/, //数字
      regEnSymbol = /[`~!@#$%^&*()\-_=+{};:<,.>?]/; //英文特殊字符

    if (str.length >= 6 && str.length <= 18) {
      if (regEnUp.test(str)) {
        if (regEnLow.test(str)) {
          if (regNum.test(str)) {
            if (regEnSymbol.test(str)) {
              return true;
            } else {
              return false;
            }
          } else {
            return false;
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    } else {
      return false;
    }
  },
  loadEncpt() {
    // 加载encruptjs
    if (window.JSEncrypt) {
      return new Promise((r) => {
        r(true);
      });
    }

    return this.load(config.encryptjs);
  },
  encrypt(c) {
    // 加密字符
    return this.loadEncpt().then(() => {
      const encrypt = new JSEncrypt();
      const publickey = config.encryptPublic; //公钥
      encrypt.setPublicKey(publickey);
      return encrypt.encrypt(c);
    });
  },
  unencrypt(c) {
    // 解密字符
    return this.loadEncpt().then(() => {
      const encrypt = new JSEncrypt();
      const pravitekey = config.encryptPravite;
      encrypt.setPrivateKey(pravitekey);
      return encrypt.decrypt(c);
    });
  },
  hex2str(hex) {
    const trimedStr = hex.trim();
    const rawStr =
      trimedStr.substr(0, 2).toLowerCase() === "0x"
        ? trimedStr.substr(2)
        : trimedStr;
    const len = rawStr.length;
    if (len % 2 !== 0) {
      console.log("Illegal Format ASCII Code!");
      return;
    }
    let curCharCode;
    const resultStr = [];
    for (let i = 0; i < len; i = i + 2) {
      curCharCode = parseInt(rawStr.substr(i, 2), 16);
      resultStr.push(String.fromCharCode(curCharCode));
    }

    return resultStr.join("");
  },
  uniKey(length) {
    // 生成唯一文件名
    let g = "";
    let i = length || 32;
    let now = +new Date();
    while (i--) {
      g += Math.floor(Math.random() * 16.0).toString(16);
    }

    return g + now;
  },
  UK() {
    // UK key
    return _UID;
  },
  UNK() {
    // UNK key
    return _UNID;
  },
  getCookie(key) {
    // 获取cookie
    const reg = new RegExp(key + "=(.+?)(?:;|$)");
    const match = document.cookie.match(reg);

    return (match && match[1]) || "";
  },
  setCookie(obj) {
    // 设置cookie
    const name = obj["name"];
    const value = obj["value"];
    const expires = obj["expires"]
      ? `expires=${new Date(
          +new Date() + (obj["expires"] * 24 + 8) * 60 * 60 * 1000
        ).toUTCString()};`
      : "";
    const path = obj["path"] ? `path=${obj["path"]};` : "";
    const domain = obj["domain"] ? `domain=${obj["domain"]};` : "";
    if (!name || !value) {
      // eslint-disable-next-line
      console.log("信息不完整");
      return;
    }
    document.cookie = `${name}=${value};${expires}${domain}${path}${cookieSecure}`;
  },
  checkLogin() {
    // console.log(this.getUid(),this.getUnid())
    // 检查用户登录信息是否过期
    const isLogin = this.getUid() && this.getUnid();

    return isLogin;
  },
  jump(pagename, isNew = false) {
    // 跳转页面方法
    const url = config.webRoot + pagename;
    window.open(url, isNew ? "_blank" : "_self");
  },
  jumpOut(pagename) {
    window.open(pagename, "_blank");
  },
  obj2Str(obj, pre = "?") {
    // 将对象转换为字符串参数
    let strArr = [];

    for (let i in obj) {
      strArr.push(`${i}=` + encodeURIComponent(obj[i]));
    }

    return strArr.length > 0 ? pre + strArr.join("&") : "";
  },
  goLogin() {
    // 跳转登录
    this.jump("/login", false);
  },
  create4() {
    // 生成32位随机数
    let nonce = "";
    const str = [
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "A",
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "H",
      "I",
      "J",
      "K",
      "L",
      "M",
      "N",
      "O",
      "P",
      "Q",
      "R",
      "S",
      "T",
      "U",
      "V",
      "W",
      "X",
      "Y",
      "Z",
    ];
    for (let i = 0, len = 4; i < len; i++) {
      nonce += str[Math.floor(Math.random() * str.length)];
    }

    return nonce;
  },
  create32() {
    // 生成32位随机数
    let nonce = "";
    const str = [
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "A",
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "H",
      "I",
      "J",
      "K",
      "L",
      "M",
      "N",
      "O",
      "P",
      "Q",
      "R",
      "S",
      "T",
      "U",
      "V",
      "W",
      "X",
      "Y",
      "Z",
    ];
    for (let i = 0, len = 32; i < len; i++) {
      nonce += str[Math.floor(Math.random() * str.length)];
    }

    return nonce;
  },
  getUid() {
    // 获取uid
    const value = this.getCookie(_UID);

    return value || "";
  },
  getUnid() {
    // 获取unid
    const value = this.getCookie(_UNID);

    return value || "";
  },
  generateSign(arr) {
    // 合成sign
    let sign = "";
    arr.sort();
    for (let o in arr) {
      sign += `${arr[o]}&`;
    }
    const code = sign.replace(/&$/g, "") + config.apiKey;

    return sha1(code);
  },
  userKeys() {
    // 获取用户信息
    const time = Date.parse(new Date()) / 1000;
    const nonce = this.create32();
    const uid = this.getUid();
    const unid = this.getUnid();
    const querys = [
      "jsonrpc=2.0",
      `timetamp=${time}`,
      `platform=pc`,
      `nonce=${nonce}`,
    ];

    if (uid) {
      querys.push(`uid=${uid}`);
    }

    if (unid) {
      querys.push(`unid=${unid}`);
    }

    const sign = this.generateSign(querys);

    return {
      jsonrpc: "2.0",
      timetamp: time,
      platform: "pc",
      nonce: nonce,
      sign: sign,
      uid: uid,
      unid: unid,
    };
  },
  noUidUserKeys() {
    // 获取用户信息
    const time = Date.parse(new Date()) / 1000;
    const nonce = this.create32();
    const uid = '';
    const unid = '';
    const querys = [
      "jsonrpc=2.0",
      `timetamp=${time}`,
      `platform=pc`,
      `nonce=${nonce}`
    ];

    if (uid) {
      querys.push(`uid=${uid}`);
    }

    if (unid) {
      querys.push(`unid=${unid}`);
    }

    const sign = this.generateSign(querys);

    return {
      jsonrpc: "2.0",
      timetamp: time,
      platform: "pc",
      nonce: nonce,
      sign: sign,
      uid: uid,
      unid: unid
    };
  },
  clearUser() {
    // 清除浏览器用户信息
    const uid = {
      name: this.UK(),
      value: "1",
      expires: -1,
      path: "/",
    };
    const unid = {
      name: this.UNK(),
      value: "1",
      expires: -1,
      path: "/",
    };
    this.setCookie(uid);
    this.setCookie(unid);
  },
  myAxios(url, data = {}) {
    const userKeys = this.userKeys();
    Object.assign(data, userKeys);
    data = qs.stringify(data);
    return Vue.prototype.$axios.post(url, data).then((e) => {
      console.log(e);
      return e.data.result;
    });
  },
  uniqObjInArray(objarray) {
    let res = objarray;
    let obj = {};

    res = res.reduce((cur, next) => {
      obj[next.type] ? "" : (obj[next.type] = true && cur.push(next));
      return cur;
    }, []);

    return res;
  },
  uniqObjInArray1(objarray) {
    let res = objarray;
    let obj = {};

    res = res.reduce((cur, next) => {
      obj[next.uid] ? "" : (obj[next.uid] = true && cur.push(next));
      return cur;
    }, []);

    return res;
  },
  uniqObjInArrayName(objarray) {
    let res = objarray;
    let obj = {};

    res = res.reduce((cur, next) => {
      obj[next.name] ? "" : (obj[next.name] = true && cur.push(next));
      return cur;
    }, []);

    return res;
  },
  myFetch(url, params = {}) {
    // api请求方法
    // 20190722重新整理参数，接收：
    // data：接口接收字段，如果不传则取整个params（为兼容旧写法）
    // method：接口请求方式，默认post
    // needLogin：是否需要登录
    // hideLoading：是否隐藏loading

    const isLogin = this.checkLogin();
    const method = params.method || "post";
    const needLogin = params.hasOwnProperty("needLogin")
      ? params.needLogin
      : true;
    const hideLoading = params.hasOwnProperty("hideLoading")
      ? params.hideLoading
      : false;
    const data = params.data || params;
    const signal = params.signal ? params.signal : "";

    if (!isLogin && needLogin) {
      this.goLogin();
      return;
    }

    if (!hideLoading) {
      Vue.prototype.$loading.open();
    }

    const options = {};
    options["method"] = method;

    const userKeys = this.userKeys();
    Object.assign(data, userKeys);

    if (method === "get") {
      url = url + this.obj2Str(data, "&");
    } else {
      const formData = new FormData();
      for (const k in data) {
        if (data.hasOwnProperty(k)) {
          formData.append(k, data[k]);
        }
      }

      options["body"] = formData;
    }

    if (signal) {
      console.log(signal);
      options["signal"] = signal;
    }

    return fetch(url, options)
      .then((res) => {
        if (res.status === 500) {
          Vue.prototype.$toast("后台服务出错啦，联系网络运维人员吧");
          Vue.prototype.$loading.close();
        }
        // console.log(res)
        return res.json();
      })
      .then(async (data) => {
        Vue.prototype.$loading.close();
        const code = data.code - 0;
        if (code === 10000) {
          // 正常返回
          return data.result;
        } else if (code === 10006) {
          Vue.prototype.$toast(data.error.message);
          return {
            needReBind: true,
          };
        } else if (code === 10009 || code === 10010) {
          Vue.prototype.$toast(data.error.message);
          // 需要图形验证码
          return {
            needVerify: true,
          };
        } else if (code - 0 === 10011) {
          Vue.prototype.$toast(data.error.message);
          // 需要图形验证码
          return {
            needVerify: true,
          };
        } else if (code === 90001) {
          // 需重新登录
          this.clearUser();
          this.goLogin();
        } else if (code === 90999) {
          Vue.prototype.$toast("无访问权限");

          this.redirectIndex();
          // window.history.go(-1)
          return null;
        } else if (code === 90998) {
          Vue.prototype.$toast(data.error.message);
          setTimeout(() => {
            if (window.close()) {
              window.close();
            } else {
              const url =
                window.location.origin +
                window.location.pathname +
                "/mediaPublishAudit/xinmeitifabushenhe";

              window.location.replace(url);
            }
          }, 2000);
          // window.close();
          // window.history.go(-1)
          return null;
        } else if (code - 0 === 11111) {
          // console.log(data.r)
          let config = {
            showIcon: false,
            title: "温馨提示",
            btn1: "确定",
            msg: data.error.message.msg,
            uid: data.error.message.uid,
            type: data.r == "newmedia/webapi/cancel" ? "authLocked" : "locked",
          };
          Vue.prototype.$MediaPlatformNotifyAuth(config).then((e) => {
            if (e) {
              if (data.r != "newmedia/webapi/cancel") {
                window.close();
              }
            }
          });

          // this.redirectIndex();
          // window.history.go(-1)
          return null;
        } else {
          if (data.error.message === "请使用内网访问媒资网") {
            Vue.prototype.$confirmTitle({
              title: "无法登陆媒资网",
              msg: "请使用工号登陆SMGstaff或者进入SMG集团内网",
              isCg: true,
            });
          } else if (data.error.message === "未绑定媒资账号") {
            let msg = `请先绑定媒资账号`;
            const confirm = await Vue.prototype.$confirm(msg);
            if (confirm) {
              window.location.href = "/user";
            }
          } else {
            if (data.r == "newmedia/webapi/releasecheck") {
              return {
                showErr: true,
                msg: data.error.message,
              };
            } else if (data.r == "newmedia/webapi/set-verify-title") {
              Vue.prototype.$auditDialog({
                type: "notice",
                title: "温馨提示",
                content1: data.error.message,
                content2: "",
                btn1: "确定",
                btn2: "",
              });
            } else if (data.r == "newmedia/webapi/save-verify-template") {
              Vue.prototype.$auditDialog({
                type: "notice",
                title: "温馨提示",
                content1: data.error.message,
                content2: "",
                btn1: "确定",
                btn2: "",
              });
            } else if (data.r == "newmedia/webapi/save-verify") {
              Vue.prototype.$auditDialog({
                type: "notice",
                title: "温馨提示",
                content1: data.error.message,
                content2: "",
                btn1: "确定",
                btn2: "",
              });
            } else if (data.r == "newmedia/webapi/del-verify-template") {
              Vue.prototype.$auditDialog({
                type: "notice",
                title: "温馨提示",
                content1: data.error.message,
                content2: "",
                btn1: "确定",
                btn2: "",
              });
            } else if (data.r == "admin/newmedia/set-verify-title") {
              Vue.prototype.$auditDialog({
                type: "notice",
                title: "温馨提示",
                content1: data.error.message,
                content2: "",
                btn1: "确定",
                btn2: "",
              });
            } else if (data.r == "admin/newmedia/save-verify-template") {
              Vue.prototype.$auditDialog({
                type: "notice",
                title: "温馨提示",
                content1: data.error.message,
                content2: "",
                btn1: "确定",
                btn2: "",
              });
            } else if (data.r == "admin/newmedia/save-verify") {
              Vue.prototype.$auditDialog({
                type: "notice",
                title: "温馨提示",
                content1: data.error.message,
                content2: "",
                btn1: "确定",
                btn2: "",
              });
            } else if (data.r == "admin/newmedia/del-verify-template") {
              Vue.prototype.$auditDialog({
                type: "notice",
                title: "温馨提示",
                content1: data.error.message,
                content2: "",
                btn1: "确定",
                btn2: "",
              });
            } else if (data.r == "newmedia/webapi/verify-template-list") {
              return {
                showErr: true,
                msg: data.error.message,
              };
            } else {
              Vue.prototype.$toast(data.error.message);
            }
          }
          return null;
        }
      })
      .catch((e) => {
        // eslint-disable-next-line
        console.log(e);
        // Vue.prototype.$toast((e && e.message) || "出错啦，请稍后重试~");
        // Vue.prototype.$loading.close();
        // return null
      });
  },
  myAxiosUploadFile(url, params, requestSet = {}) {
    const isLogin = this.checkLogin();
    const needLogin = params.hasOwnProperty("needLogin")
      ? params.needLogin
      : true;
    if (!isLogin && needLogin) {
      this.goLogin();
      return;
    }

    const data = params.data || params;

    const userKeys = this.userKeys();
    Object.assign(data, userKeys);
    const formData = new FormData();
    for (const k in data) {
      if (data.hasOwnProperty(k)) {
        formData.append(k, data[k]);
      }
    }

    return Vue.prototype.$axios
      .post(url, formData, requestSet)
      .then((res) => {
        console.log("axios res", res);
        if (res.status === 500) {
          Vue.prototype.$toast("后台服务出错啦，联系网络运维人员吧");
        }
        return res.data;
      })
      .then(async (data) => {
        Vue.prototype.$loading.close();
        const code = data.code - 0;
        if (code === 10000) {
          // 正常返回
          return data.result;
        } else if (code === 10006) {
          Vue.prototype.$toast(data.error.message);
          return {
            needReBind: true,
          };
        } else if (code === 10009 || code === 10010) {
          Vue.prototype.$toast(data.error.message);
          // 需要图形验证码
          return {
            needVerify: true,
          };
        } else if (code - 0 === 10011) {
          Vue.prototype.$toast(data.error.message);
          // 需要图形验证码
          return {
            needVerify: true,
          };
        } else if (code === 90001) {
          // 需重新登录
          this.clearUser();
          this.goLogin();
        } else if (code === 90999) {
          Vue.prototype.$toast("无访问权限");

          this.redirectIndex();
          // window.history.go(-1)
          return null;
        } else if (code === 90998) {
          Vue.prototype.$toast(data.error.message);
          setTimeout(() => {
            if (window.close()) {
              window.close();
            } else {
              const url =
                window.location.origin +
                window.location.pathname +
                "/mediaPublishAudit/xinmeitifabushenhe";

              window.location.replace(url);
            }
          }, 2000);
          // window.close();
          // window.history.go(-1)
          return null;
        } else if (code - 0 === 11111) {
          // console.log(data.r)
          let config = {
            showIcon: false,
            title: "温馨提示",
            btn1: "确定",
            msg: data.error.message.msg,
            uid: data.error.message.uid,
            type: data.r == "newmedia/webapi/cancel" ? "authLocked" : "locked",
          };
          Vue.prototype.$MediaPlatformNotifyAuth(config).then((e) => {
            if (e) {
              if (data.r != "newmedia/webapi/cancel") {
                window.close();
              }
            }
          });

          // this.redirectIndex();
          // window.history.go(-1)
          return null;
        } else {
          if (data.error.message === "请使用内网访问媒资网") {
            Vue.prototype.$confirmTitle({
              title: "无法登陆媒资网",
              msg: "请使用工号登陆SMGstaff或者进入SMG集团内网",
              isCg: true,
            });
          } else if (data.error.message === "未绑定媒资账号") {
            let msg = `请先绑定媒资账号`;
            const confirm = await Vue.prototype.$confirm(msg);
            if (confirm) {
              window.location.href = "/user";
            }
          } else {
            if (data.r == "newmedia/webapi/releasecheck") {
              return {
                showErr: true,
                msg: data.error.message,
              };
            } else if (data.r == "newmedia/webapi/set-verify-title") {
              Vue.prototype.$auditDialog({
                type: "notice",
                title: "温馨提示",
                content1: data.error.message,
                content2: "",
                btn1: "确定",
                btn2: "",
              });
            } else if (data.r == "newmedia/webapi/save-verify-template") {
              Vue.prototype.$auditDialog({
                type: "notice",
                title: "温馨提示",
                content1: data.error.message,
                content2: "",
                btn1: "确定",
                btn2: "",
              });
            } else if (data.r == "newmedia/webapi/save-verify") {
              Vue.prototype.$auditDialog({
                type: "notice",
                title: "温馨提示",
                content1: data.error.message,
                content2: "",
                btn1: "确定",
                btn2: "",
              });
            } else if (data.r == "newmedia/webapi/del-verify-template") {
              Vue.prototype.$auditDialog({
                type: "notice",
                title: "温馨提示",
                content1: data.error.message,
                content2: "",
                btn1: "确定",
                btn2: "",
              });
            } else if (data.r == "admin/newmedia/set-verify-title") {
              Vue.prototype.$auditDialog({
                type: "notice",
                title: "温馨提示",
                content1: data.error.message,
                content2: "",
                btn1: "确定",
                btn2: "",
              });
            } else if (data.r == "admin/newmedia/save-verify-template") {
              Vue.prototype.$auditDialog({
                type: "notice",
                title: "温馨提示",
                content1: data.error.message,
                content2: "",
                btn1: "确定",
                btn2: "",
              });
            } else if (data.r == "admin/newmedia/save-verify") {
              Vue.prototype.$auditDialog({
                type: "notice",
                title: "温馨提示",
                content1: data.error.message,
                content2: "",
                btn1: "确定",
                btn2: "",
              });
            } else if (data.r == "admin/newmedia/del-verify-template") {
              Vue.prototype.$auditDialog({
                type: "notice",
                title: "温馨提示",
                content1: data.error.message,
                content2: "",
                btn1: "确定",
                btn2: "",
              });
            } else if (data.r == "newmedia/webapi/verify-template-list") {
              return {
                showErr: true,
                msg: data.error.message,
              };
            } else {
              Vue.prototype.$toast(data.error.message);
              return false;
            }
          }
          return null;
        }
      })
      .catch((e) => {
        // eslint-disable-next-line
        console.log(e);
        // Vue.prototype.$toast((e && e.message) || "出错啦，请稍后重试~");
        // Vue.prototype.$loading.close();
        // return null
      });
  },
  thirdNav(url, params = {}) {
    // api请求方法
    // 20190722重新整理参数，接收：
    // data：接口接收字段，如果不传则取整个params（为兼容旧写法）
    // method：接口请求方式，默认post
    // needLogin：是否需要登录
    // hideLoading：是否隐藏loading

    const isLogin = this.checkLogin();
    const method = params.method || "post";
    const needLogin = params.hasOwnProperty("needLogin")
      ? params.needLogin
      : true;
    const hideLoading = params.hasOwnProperty("hideLoading")
      ? params.hideLoading
      : false;
    const data = params.data || params;

    if (!isLogin && needLogin) {
      this.goLogin();
      return;
    }

    const userKeys = this.userKeys();
    Object.assign(data, userKeys);

    if (method === "get") {
      url = url + this.obj2Str(data, "&");
    }

    window.open(url);

    console.log(url);
  },
  redirectIndex() {
    // 重定向到首页
    const url = window.location.origin + window.location.pathname + "/index";

    window.location.replace(url);
  },
  doubleDigit(n) {
    // 将数字转为两位，不足补零
    if (n / 10 < 1) {
      return `0${n}`;
    }

    return `${n}`;
  },
  stampToTime(s) {
    // 将时间戳转换为时间
    if (!s) {
      return "";
    }

    const year = s.getFullYear();
    const month = this.doubleDigit(s.getMonth() + 1);
    const day = this.doubleDigit(s.getDate());
    const hour = this.doubleDigit(s.getHours());
    const minute = this.doubleDigit(s.getMinutes());
    const second = this.doubleDigit(s.getSeconds());

    return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
  },
  stampToDate(s) {
    // 将时间戳转换为时间
    if (!s) {
      return "";
    }

    const year = s.getFullYear();
    const month = this.doubleDigit(s.getMonth() + 1);
    const day = this.doubleDigit(s.getDate());

    return `${year}-${month}-${day}`;
  },
  allRequired(l) {
    // 必填项是否都满足，是返回true，否返回false
    let f = true;
    l.forEach((i) => {
      if (!i) {
        f = false;
      }
    });

    return f;
  },
  calculatePage(total, size) {
    // 计算页数
    let page = 0;
    if (total % size === 0) {
      page = total / size;
    } else {
      page = parseInt(total / size) + 1;
    }

    return page;
  },
  exportRes(url, data, status) {
    // 使用post导出文件
    // data = JSON.stringify(data)
    // url = encodeURIComponent(url);
    // // console.log(url)
    // // const windowFeatures = "menubar=no,location=yes,resizable=yes,scrollbars=no,status=yes";
    // // window.open('/downloadTest/'+url+'/'+data)
    // const url = 'https://media.smgtech.net:8443/radio/original/2020/10/30/32a22cf0-1a4d-11eb-ace1-0050569c5c7a.mxf'
    // const fileStream = streamSaver.createWriteStream('cat.mp4')

    // fetch(url).then(res => {
    //   const readableStream = res.body

    //   // more optimized
    //   if (window.WritableStream && readableStream.pipeTo) {
    //     return readableStream.pipeTo(fileStream)
    //       .then(() => console.log('done writing'))
    //   }

    //   window.writer = fileStream.getWriter()

    //   const reader = res.body.getReader()
    //   const pump = () => reader.read()
    //     .then(res => res.done
    //       ? writer.close()
    //       : writer.write(res.value).then(pump))

    //   pump()
    // })
    // return false;

    if (status == 1) {
      let userKeys = {
        api_version: 1,
      };

      const params = Object.assign({}, data, userKeys);

      this.myFetch(url, params).then((r) => {
        if (r) {
          console.log(r);

          let link, evt;

          link = document.createElement("a");
          // link.download = r.file_title;
          link.href = r.download_url;
          link.setAttribute("download", r.file_title);
          if (document.fireEvent) {
            window.open(link.href);
          } else {
            evt = document.createEvent("MouseEvents");
            evt.initEvent("click", true, true);
            link.dispatchEvent(evt);
          }
          // link.click()
          // evt = document.createEvent('MouseEvents');
          // evt.initEvent('click', true, true);
          // link.dispatchEvent(evt);
        }
      });
    } else {
      const body = document.body;
      const form = document.createElement("form");
      form.method = "post";
      form.action = url;
      for (let k in data) {
        if (data.hasOwnProperty(k)) {
          const p = document.createElement("input");
          p.type = "hidden";
          p.name = k;
          p.value = data[k];
          form.appendChild(p);
        }
      }
      body.appendChild(form);
      form.submit();
      body.removeChild(form);
    }

    // return false

    // const body = document.body;
    // const form = document.createElement("form");
    // form.method = "post";
    // form.action = url;
    // for (let k in data) {
    //   if (data.hasOwnProperty(k)) {
    //     const p = document.createElement("input");
    //     p.type = "hidden";
    //     p.name = k;
    //     p.value = data[k];
    //     form.appendChild(p);
    //   }
    // }

    // body.appendChild(form);
    // form.submit();
    // body.removeChild(form);
  },
  load(src, type) {
    return script.load(src, type);
  },
  formatXNSAudios(doc = document) {
    // 处理xns音频标签
    replaceArr = [];
    const audiotags = doc.getElementsByClassName("_xnsaudiotag");
    for (let i = 0; i < audiotags.length; i++) {
      this.replaceXNSAudios(audiotags[i]);
    }
    for (let i = 0; i < replaceArr.length; i++) {
      replaceArr[i].father.replaceChild(replaceArr[i].dom, replaceArr[i].tag);
    }
  },
  timeEvent(e) {
    let time = e;
    let len = time.split(":");
    if (len.length == 3) {
      let hour = time.split(":")[0];
      let min = time.split(":")[1];
      let sec = time.split(":")[2];
      return Number(hour * 3600) + Number(min * 60) + Number(sec);
    }
    if (len.length == 2) {
      let min = time.split(":")[0];
      let sec = time.split(":")[1];
      return Number(min * 60) + Number(sec);
    }
    if (len.length == 1) {
      let sec = time.split(":")[0];
      return Number(sec);
    }
  },
  replaceXNSAudios(tag) {
    // 将内容中音频替换为自定义样式
    const idstring = tag.getAttribute("idstring");
    const father = tag.parentNode;
    const origin = window.location.origin || "https://testxnews.smgtech.net";
    console.log(
      "replaceXNSAudios audio的地址 src属性2",
      tag.getAttribute("src")
    );
    let url = tag.getAttribute("src") || tag.innerText;
    console.log("replaceXNSAudios audio的地址 innerText", url);
    const audioString =
      '<iframe _src="' +
      url +
      '" class="smg-audio" frameborder="0" width="100%" height="80" src="' +
      origin +
      "/static/xnsaudio/audio.html?is=" +
      idstring +
      '" allowFullScreen="false"></iframe>';
    const parser = new DOMParser();
    const dom = parser.parseFromString(audioString, "text/html").body
      .firstChild;
    replaceArr.push({
      dom: dom,
      tag: tag,
      father: father,
    });
    // father.replaceChild(dom, tag);
  },
  replaceXNSAudios1(tag) {
    // 将内容中音频替换为自定义样式
    const idstring = tag.getAttribute("idstring");
    const father = tag.parentNode;
    const origin = window.location.origin || "https://testxnews.smgtech.net";
    console.log(
      "replaceXNSAudios audio的地址 src属性2",
      tag.getAttribute("src")
    );
    let url = tag.getAttribute("src") || tag.innerText;
    console.log("replaceXNSAudios audio的地址 innerText", url);
    let audioString = "";
    if (idstring) {
      audioString =
        '<iframe _src="' +
        url +
        '" class="smg-audio" frameborder="0" width="100%" height="80" src="' +
        origin +
        "/static/xnsaudio/audio.html?is=" +
        idstring +
        '" allowFullScreen="false"></iframe>';

      const parser = new DOMParser();
      const dom = parser.parseFromString(audioString, "text/html").body
        .firstChild;
      father.replaceChild(dom, tag);
    }
  },
  getFileConfigs() {
    // 获取文件上传服务器配置信息
    return this.myFetch(config.apis.File_config, {}).then((r) => {
      if (r) {
        return r;
      }
    });
  },
  getUserInfo() {
    // 获取用户信息及菜单，通过session防止重复请求
    let info = dc.getUsrInfo();

    if (info) {
      return new Promise((r, j) => {
        r(info);
      });
    }

    return this.myFetch(config.apis.Usr_menu, {}).then((r) => {
      if (r) {
        // dc.setUsrInfo(r)
        return r;
      }
    });
  },
  getPlatform() {
    // 获取操作系统类型
    let OS = "";
    let OSArray = {};
    OSArray.win =
      navigator.platform == "Win32" || navigator.platform == "Windows";
    OSArray.mac =
      navigator.platform == "Mac68K" ||
      navigator.platform == "MacPPC" ||
      navigator.platform == "Macintosh" ||
      navigator.platform == "MacIntel";
    // OSArray.iphone = UserAgent.indexOf('iPhone') > -1
    // OSArray.ipod = UserAgent.indexOf('iPod') > -1
    // OSArray.ipad = UserAgent.indexOf('iPad') > -1
    // OSArray.Android = UserAgent.indexOf('Android') > -1
    for (let i in OSArray) {
      if (OSArray[i]) {
        OS = i;
      }
    }

    return OS;
  },
  cleanAllAngles(string) {
    // 去掉所有带尖括号内容
    const result = string ? string.replace(/<[^>]+>/g, "") : "";

    return result;
  },
  cleanHtml(string) {
    // 清除文本中html标签
    const result = string
      ? string
          .replace(
            /<\/(a|abbr|acronym|address|applet|area|article|aside|audio|b|base|basefont|bdi|bdo|big|blockquote|body|br|button|canvas|caption|center|cite|code|col|colgroup|command|datalist|dd|del|details|dfn|dialog|dir|div|dl|dt|em|embed|fieldset|figcaption|figure|font|footer|form|frame|frameset|h1|h2|h3|h4|h5|h6|head|header|hr|html|i|iframe|img|input|ins|kbd|keygen|label|legend|li|link|map|mark|menu|meta|meter|nav|noframes|noscript|object|ol|optgroup|option|output|p|param|pre|progress|q|rp|rt|ruby|s|samp|script|section|select|small|source|span|strike|strong|style|sub|summary|sup|table|tbody|td|textarea|tfoot|th|thead|time|title|tr|track|tt|u|ul|var|video|wbr)>/g,
            ""
          )
          .replace(
            /<\s*(a|abbr|acronym|address|applet|area|article|aside|audio|b|base|basefont|bdi|bdo|big|blockquote|body|br|button|canvas|caption|center|cite|code|col|colgroup|command|datalist|dd|del|details|dfn|dialog|dir|div|dl|dt|em|embed|fieldset|figcaption|figure|font|footer|form|frame|frameset|h1|h2|h3|h4|h5|h6|head|header|hr|html|i|iframe|img|input|ins|kbd|keygen|label|legend|li|link|map|mark|menu|meta|meter|nav|noframes|noscript|object|ol|optgroup|option|output|p|param|pre|progress|q|rp|rt|ruby|s|samp|script|section|select|small|source|span|strike|strong|style|sub|summary|sup|table|tbody|td|textarea|tfoot|th|thead|time|title|tr|track|tt|u|ul|var|video|wbr)[^>]*>/g,
            ""
          )
      : "";

    return result;
  },
  cleanHtmlTags(s) {
    const tags = htmltaglist.join("|");
    const regF = new RegExp(`<\/(${tags})>`, "g");
    const regB = new RegExp(`<\s*(${tags})[^>]*>`, "g");

    return s ? s.replace(regF, "").replace(regB, "") : "";
  },
  escapeEscapes(s) {
    // 将转义后的内容转义为普通文本
    let p = document.createElement("p");
    let r = "";
    p.innerHTML = s;
    r = p.innerText || p.textContent;
    p = null;

    return r;
  },
  getBodyText(h) {
    // 返回稿件中正文文字
    const body = h.split("[导语]")[0].split("[正文]")[1];

    return this.cleanHtml(body);
  },
  getLeadText(h) {
    // 返回稿件中导语文字
    const lead = h.split("[编后]")[0].split("[导语]")[1];

    return this.cleanHtml(lead);
  },
  getAfterText(h) {
    const after = h.split("[记者]")[0].split("[编后]")[1];

    return this.cleanHtml(after);
  },
  getBody(h) {
    // 返回稿件中正文文字，不过滤尖括号
    const body = h.split("[导语]")[0].split("[正文]")[1];

    return body || "";
  },
  getBody1(h) {
    // 返回稿件中正文文字，不过滤尖括号
    const body = h.split("[正文]")[1].split("[编后]")[0];

    return body || "";
  },
  getLead(h) {
    // 返回稿件中导语文字
    const lead = h.split("[编后]")[0].split("[导语]")[1];

    return lead || "";
  },
  getLead1(h) {
    // 返回稿件中导语文字
    const lead = h.split("[导语]")[1].split("[正文]")[0];

    return lead || "";
  },
  getAfter(h) {
    const after = h.split("[记者]")[0].split("[编后]")[1];

    return after || "";
  },
  getAfter1(h) {
    const after = h.split("[编后]")[1];

    return after || "";
  },
  getReporterText(h) {
    const reporter = h.split("[摄像]")[0].split("[记者]")[1];

    return this.cleanHtml(reporter);
  },
  getVideoText(h) {
    const video = h.split("[摄像]")[1];

    return this.cleanHtml(video);
  },
  loadSct() {
    // 加载js文件
    if (window.WebSocket) {
      return new Promise((r, j) => {
        r(true);
      });
    }

    return this.load(config.websocketjs);
  },
  handleSocket(fn, type) {
    // 接收每个socket通知并处理
    const url = config.socketUrl;
    let msg = {};

    socketListeners = socketListeners.filter((el) => {
      return el.type != type;
    });

    socketListeners.push({
      fn: fn,
      type: type,
    });

    const listeners = this.uniqObjInArray(socketListeners);

    // const listeners = Array.from(new Set(socketListeners));

    this.loadSct().then(() => {
      socket = socket || new WebSocket(url);
      const ws = socket;
      ws.onopen = () => {
        const loginData = {
          type: "login",
          uid: this.userKeys().uid,
          unid: this.userKeys().unid,
          room_id: 1,
        };

        ws.send(JSON.stringify(loginData));
        console.log("socket已连接");
      };

      ws.onclose = () => {
        console.log("socket连接关闭，正在重连");
        setTimeout(() => {
          this.handleSocket(fn, type);
        }, 3000);
      };

      ws.onerror = function () {
        console.log("socket连接错误");
      };

      ws.onmessage = (r) => {
        msg = JSON.parse(r.data);

        if (msg.type === "ping") {
          ws.send('{"type":"pong"}');
          return;
        }
        listeners.forEach((i) => {
          if (i.fn && msg.type === i.type) {
            i.fn(msg);
          }
        });

        // if (fn && msg.type === type) {
        //   fn(msg)
        // }
      };
    });
  },
  sendSocket(data) {
    // 发送一次socket请求
    const url = config.socketUrl;

    this.loadSct().then(() => {
      socket = socket || new WebSocket(url);
      const ws = socket;

      ws.send(JSON.stringify(data));
    });
  },
  async getAllMedia(data = null, id = "", type = 0) {
    let files =
      data ||
      (await this.myFetch(config.apis.File_status, {
        subject_id: id,
        subject_type: type,
      }));
    const filelist = [];

    if (!files) return;

    console.log(files);

    files.img_list.forEach((i) => {
      filelist.push({
        id: i.id,
      });
    });

    files.video_list.forEach((v) => {
      if (v.content.status == 1) {
        filelist.push({
          id: v.id,
        });
      }
    });

    files.sound_list.forEach((s) => {
      if (s.content.status == 1) {
        filelist.push({
          id: s.id,
        });
      }
    });

    console.log("list 内部", filelist);
    return filelist;
  },
  async getAllMedia1(data = null, id = "", type = 0) {
    let files =
      data ||
      (await this.myFetch(config.apis.File_status, {
        subject_id: id,
        subject_type: type,
      }));
    const filelist = [];

    if (!files) return;

    console.log(files);

    files.img_list.forEach((i) => {
      filelist.push({
        id: i.id,
      });
    });

    files.video_list.forEach((v) => {
      // if (v.content.status == 1) {
      filelist.push({
        id: v.id,
      });
      // }
    });

    files.sound_list.forEach((s) => {
      // if (s.content.status == 1) {
      filelist.push({
        id: s.id,
      });
      // }
    });

    console.log("list 内部", filelist);
    return filelist;
  },
  async viewMedia(
    data = null,
    now = null,
    download = false,
    id = "",
    type = 0
  ) {
    let files =
      data ||
      (await this.myFetch(config.apis.File_status, {
        subject_id: id,
        subject_type: type,
      }));
    const filelist = [];

    if (!files) return;

    files.img_list.forEach((i) => {
      filelist.push({
        url: i.url,
        type: i.type - 0,
        downloadUrl: i.download_url,
      });
    });

    files.video_list.forEach((v) => {
      if (v.content.status == 1) {
        filelist.push({
          url: v.url,
          type: v.type - 0,
          downloadUrl: v.download_url,
        });
      }
    });

    files.sound_list.forEach((s) => {
      if (s.content.status == 1) {
        filelist.push({
          url: s.url,
          type: s.type - 0,
          downloadUrl: s.download_url,
        });
      }
    });

    console.log("list", filelist);
    if (filelist.length > 0) {
      Vue.prototype.$viewer(filelist, now, download);
    }
  },
  async openMaterialBox(
    data = null,
    now = null,
    download = false,
    id = "",
    type = 0
  ) {
    now = 0;
    let files =
      data ||
      (await this.myFetch(config.apis.File_status, {
        subject_id: id,
        subject_type: type,
      }));
    const filelist = [];

    if (!files) return;

    console.log(files);

    files.video_list.forEach((v) => {
      if (v.content.status == 1) {
        filelist.push({
          id: v.id,
          idstring: v.idstring,
        });
      }
    });

    files.sound_list.forEach((s) => {
      if (s.content.status == 1) {
        filelist.push({
          id: s.id,
          idstring: s.idstring,
        });
      }
    });

    files.img_list.forEach((i) => {
      filelist.push({
        id: i.id,
        idstring: i.idstring,
      });
    });

    console.log("list", filelist, store);
    let i = {
      index: now || 0,
      list: filelist,
      canEdit: false,
      create: store.state.create,
      quickEdit: store.state.quickEdit,
    };
    if (filelist.length > 0) {
      Vue.prototype.$materialBox("", "", i);
      // Vue.prototype.$viewer(filelist, now, download);
    }
  },
  browserNotify(data) {
    if (!window.Notification) {
      console.log("浏览器不支持通知");
    } else {
      const title = data.title;
      const options = {
        dir: "auto",
        body: data.body,
        requireInteraction: false,
        icon: data.img || "",
      };

      let notification = null;
      if (Notification.permission === "granted") {
        notification = new Notification(title, options);
      } else if (Notification.permission === "default") {
        Notification.requestPermission().then((permission) => {
          if (permission === "granted") {
            notification = new Notification(title, options);
          } else if (permission === "default") {
            console.log("用户关闭授权，未置可否");
          } else {
            console.log("用户已拒绝通知");
          }
        });
      } else {
        console.log("用户已拒绝通知");
      }

      notification.onclick = () => {
        if (data.type !== "weibo") {
          this.jump(`/clueDetail?d=${data.id}`, true);
        }
      };
    }
  },
  replaceBr2N(source) {
    // 将内容中所有br及p换为/n
    return source
      .replace(/\<br\/\>/g, "\n")
      .replace(/\<br\>/g, "\n")
      .replace(/\<\/p\>/g, "\n");
  },
  replaceN2Br(source) {
    // 将内容中所有/n换为br
    return source.replace(/\n/g, "<br/>");
  },
  replaceTags(source) {
    // 将英文的正文、导语、编后替换为中文
    return source
      .replace(/\[正文\]/g, "【正文】")
      .replace(/\[导语\]/g, "【导语】")
      .replace(/\[编后\]/g, "【编后】");
  },
  replacePunctuations(source) {
    // 过滤掉内容中所有空格、换行

    // return source.replace(/[\n|\ |\~|\`|\!|\@|\#|\$|\%|\^|\&|\*|\(|\)|\（|\）|\-|\_|\+|\=|\||\\|\[|\【|\】|\]|\{|「|」|\}|\;|\；|\:|\：|\"|\“|\”|\‘|\’|\'|\,|\，|\。|\<|\.|\>|\《|\》|\/|\?|\？|\～|\、]/g,"")
    return source.replace(/[\n|\ ]/g, "");
  },
  replaceBlank2NBSP(source) {
    return source.replace(/\ /g, "&nbsp;");
  },
  goTop() {
    window.document.documentElement.scrollTop = 0;
    window.document.body.scrollTop = 0;
  },
  callVideoInPicture(src) {
    const video = document.createElement("video");
    video.src = src;
    video.controls = "controls";
    video.playsinline = true;
    video.preload = true;
    video.style.display = "none";
    document.body.appendChild(video);

    video.addEventListener("enterpictureinpicture", function (e) {
      const pip = e.pictureInPictureWindow;
      pip.addEventListener("resize", function () {
        // 还需调研
        pip.width = 1000;
        pip.height = 1000;
      });
    });

    video.onloadedmetadata = async function () {
      try {
        if (video !== document.pictureInPictureElement) {
          await video.requestPictureInPicture();
        } else {
          await document.exitPictureInPicture();
        }
      } catch (error) {
        console.log("出错了！" + error);
      }
    };
  },
  hasScroller() {
    // 判断是否有滚动条
    return (
      document.body.scrollHeight >
      (window.innerHeight || document.documentElement.clientHeight)
    );
  },
  handlePageMediaCenterPosition() {
    // 在页面拉伸或拖拽滚动条时修改多媒体区的right值来实现跟随
    window.document.documentElement.scrollLeft = 0; // 为避免拖动滚动条后错位，每次拉伸后重置滚动条
    const aside = document.querySelector("._xnsAside");
    const minWidth = 1200; // 页面最小宽度，小于出现滚动条
    const basicRight = 50; // 多媒体区的初始right值
    let scrollerWidth = window.innerWidth - document.body.clientWidth; // 竖向滚动条宽度
    let pageWidth = window.innerWidth; // 浏览器窗口的宽度
    let scrollLeft = window.document.documentElement.scrollLeft; // 滚动条位置
    if (pageWidth < minWidth) {
      // 页面加载后处理
      const gap = pageWidth - minWidth;
      aside.style.right = `${basicRight + gap - scrollerWidth + scrollLeft}px`;
    }
    let initialRight = parseInt(aside.style.right); // aside的right值

    window.addEventListener("resize", () => {
      // 窗口拖拽大小时
      window.document.documentElement.scrollLeft = 0; // 为避免拖动滚动条后错位，每次拉伸后重置滚动条
      scrollerWidth = window.innerWidth - document.body.clientWidth;
      let screenWidth = minWidth + scrollerWidth;
      pageWidth = window.innerWidth;
      initialRight = parseInt(aside.style.right);
      if (pageWidth < screenWidth) {
        const gap = pageWidth - minWidth;
        aside.style.right = `${
          basicRight + gap - scrollerWidth + scrollLeft
        }px`;
      } else {
        aside.style.right = `${basicRight}px`;
      }
    });

    window.addEventListener("scroll", function () {
      // 横向滚动条拖动时
      const scrollX = window.document.documentElement.scrollLeft;
      scrollLeft = scrollX;
      scrollerWidth = window.innerWidth - document.body.clientWidth;
      // initialRight = parseInt(aside.style.right)

      if (scrollX >= 0) {
        // console.log('scroll', initialRight, scrollX, scrollerWidth)
        aside.style.right = `${initialRight + scrollX - 2}px`;
      }
    });
  },
  checkPageStatus(id, type) {
    // 检测稿件（采访和报道）状态，是否能进入编辑页
    const info = {
      subject_type: type,
      subject_id: id,
    };

    return this.myFetch(config.apis.Itv_check_status, info).then((r) => !!r);
  },
  closeMaterial() {
    Vue.prototype.$materialBox();
  },
};
